import { render, staticRenderFns } from "./BABSIslemi.vue?vue&type=template&id=27fc4c7a&"
import script from "./BABSIslemi.vue?vue&type=script&lang=js&"
export * from "./BABSIslemi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports